// TintiCloud — mapeamento semântico de status -> tom + rótulo pt-BR + classes.
export const TONES = {
  ok: { text: "text-ok", dot: "bg-ok", bg: "bg-ok/10", border: "border-ok/30", ring: "ring-ok/20" },
  warn: { text: "text-warn", dot: "bg-warn", bg: "bg-warn/10", border: "border-warn/30", ring: "ring-warn/20" },
  err: { text: "text-err", dot: "bg-err", bg: "bg-err/10", border: "border-err/30", ring: "ring-err/20" },
  info: { text: "text-info", dot: "bg-info", bg: "bg-info/10", border: "border-info/30", ring: "ring-info/20" },
  neutral: { text: "text-muted-foreground", dot: "bg-muted-foreground/60", bg: "bg-white/5", border: "border-line", ring: "ring-white/10" },
};

// status técnico -> { tone, label }
const MAP = {
  // healthy family
  online: { tone: "ok", label: "Online" },
  running: { tone: "ok", label: "Running" },
  healthy: { tone: "ok", label: "Healthy" },
  success: { tone: "ok", label: "Concluído" },
  valid: { tone: "ok", label: "Válido" },
  active: { tone: "ok", label: "Ativo" },
  dns_pending: { tone: "warn", label: "DNS pendente" },
  not_configured: { tone: "neutral", label: "Não configurado" },
  verifying: { tone: "info", label: "Verificando" },
  connected: { tone: "ok", label: "Conectado" },
  protected: { tone: "ok", label: "Protegido" },
  managed: { tone: "ok", label: "Managed" },
  // warning family
  warning: { tone: "warn", label: "Atenção" },
  standby: { tone: "warn", label: "Standby" },
  paused: { tone: "warn", label: "Pausado" },
  pending: { tone: "warn", label: "Pendente" },
  building: { tone: "warn", label: "Building" },
  deploying: { tone: "warn", label: "Deploying" },
  queued: { tone: "warn", label: "Queued" },
  drifted: { tone: "warn", label: "Drifted" },
  redirect: { tone: "info", label: "Redirect" },
  degraded: { tone: "warn", label: "Degradado" },
  // error family
  error: { tone: "err", label: "Erro" },
  offline: { tone: "err", label: "Offline" },
  stopped: { tone: "err", label: "Parado" },
  failed: { tone: "err", label: "Falhou" },
  rolled_back: { tone: "err", label: "Rollback" },
  down: { tone: "err", label: "Down" },
  missing: { tone: "err", label: "Não encontrado" },
  denied: { tone: "err", label: "Negado" },
  timed_out: { tone: "err", label: "Tempo esgotado" },
  never_connected: { tone: "warn", label: "Aguardando Agent" },
  incompatible: { tone: "err", label: "Protocolo incompatível" },
  // transient (ações sobre o site)
  starting: { tone: "warn", label: "Iniciando" },
  restarting: { tone: "warn", label: "Reiniciando" },
  stopping: { tone: "warn", label: "Parando" },
  // chamados / suporte
  open: { tone: "info", label: "Aberto" },
  in_progress: { tone: "warn", label: "Em atendimento" },
  waiting_client: { tone: "warn", label: "Aguardando cliente" },
  resolved: { tone: "ok", label: "Resolvido" },
  // info family
  info: { tone: "info", label: "Info" },
  discovered: { tone: "info", label: "Discovered" },
  unmanaged: { tone: "info", label: "Unmanaged" },
  adopted: { tone: "info", label: "Adopted" },
  // sem dados suficientes ainda para classificar (ex.: recurso recém-criado
  // antes do primeiro health check real)
  unknown: { tone: "neutral", label: "Sem dados" },
};

export function statusMeta(status) {
  return MAP[status] || { tone: "neutral", label: status };
}

// cor de utilização (barras) por percentual
export function usageTone(pct) {
  if (pct >= 85) return "err";
  if (pct >= 65) return "warn";
  return "ok";
}
